import React from 'react';
import Skeleton from '@mui/material/Skeleton';

const SkeletonContent = () => {
  const customStyle = {
    backgroundColor: '#FAC3C6',
  };
  const animationType = 'pulse';
  //const animationType = 'wave';

  return (
    <div className="content-element">

      <div className="row py-2 ips-item-row">
        <div className="d-flex justify-content align-items-center col-2 mt-1 mb-1 my-auto">
          <Skeleton animation={animationType} variant="rect" width="100%" height={40} style={{ backgroundColor: customStyle.backgroundColor }} />
        </div>
        <div className="col-8 mt-1">
          <div className="d-flex flex-row">
            <Skeleton animation={animationType} variant="text" width="80%" style={{ backgroundColor: customStyle.backgroundColor }} />
          </div>
          <div className="d-flex flex-row">
            <Skeleton animation={animationType} variant="text" width="60%" style={{ backgroundColor: customStyle.backgroundColor }} />
          </div>
        </div>
        <div className="justify-content align-items-center px-0 col-2 mt-1 mb-1 my-auto">
          <div className="d-flex ips-remove-btnselect flex-row">
            <Skeleton animation={animationType} variant="text" width="50%" style={{ backgroundColor: customStyle.backgroundColor }} />
          </div>
          <div className="d-flex ips-flex-row flex-row">
            <Skeleton animation={animationType} variant="text" width="50%" style={{ backgroundColor: customStyle.backgroundColor }} />
          </div>
        </div>
      </div>
  
  </div>
  );
};

export default SkeletonContent;